const params = new URLSearchParams(window.location.search);
const kitID = params.get('kitID');

if (kitID) {
  localStorage.setItem('siphoxKitID', kitID);
}
const customerId = ShopifyAnalytics.meta.page.customerId;

if (!customerId) {
  window.location.href = '/account/login?return_url=/pages/lab-test-registration';
}

if (!customElements.get('siphox-register-form')) {
  class SiphoxRegisterForm extends HTMLElement {
    constructor() {
      super();
    }

    fillKitId() {
      const kitID = localStorage.getItem('siphoxKitID');
      const kitIDInput = this.querySelector('#kitID');
      const siphoxKitIDFromRegisterPage = localStorage.getItem('siphoxKitID');

      if (kitIDInput) {
        kitIDInput.value = kitID || '';
      }

      if (siphoxKitIDFromRegisterPage === null || siphoxKitIDFromRegisterPage === 'null') {
        this.initRegistrationPopup();
      }
    }

    initRegistrationPopup() {
      this.registrationPopup = this.querySelector('[data-registration-popup]');

      this.registrationPopup.classList.remove('hidden');
      this.registrationPopup.classList.add('flex');

      this.registrationPopup.querySelector('.close-button').addEventListener('click', () => {
        this.registrationPopup.classList.remove('flex');
        this.registrationPopup.classList.add('hidden');
      });

      this.registrationPopup.querySelector('[type="submit"]').addEventListener('click', (e) => {
        e.preventDefault();

        const kitIdInput = this.registrationPopup.querySelector('[data-kit-id]');
        const kitIdInputValue = kitIdInput.value;

        if (kitIdInputValue.trim() === '') {
          kitIdInput.classList.add('border-red-140');
          return;
        } else {
          kitIdInput.classList.remove('border-red-140');
        }

        if (kitIdInputValue.includes('SP')) {
          this.registrationPopup.classList.add('hidden');
          this.registrationPopup.classList.remove('flex');
        } else {
          window.location.href = '/pages/panorama-lab-test-registration';
        }
      });
    }

    connectedCallback() {
      this.fillKitId();
      this.form = this.querySelector('[data-siphox-form]');

      if (this.form) {
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          const formData = new FormData(this.form);
          const params = new URLSearchParams();
          for (const [key, value] of formData.entries()) {
            params.append(key, value);
          }
          const urlParams = params.toString();

          fetch('/apps/mira-labtest/api/register-kit', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              kit_id: formData.get('kitID'),
              shopify_customer_id: ShopifyAnalytics.meta.page.customerId,
              email: formData.get('email'),
              birthday: formData.get('birthday'),
              gender: formData.get('gender'),
              first_name: formData.get('firstName'),
              last_name: formData.get('lastName'),
            }),
          })
            .then((res) => res.json())
            .then((response) => {
              if (response.message) {
                this.form.insertAdjacentHTML(
                  'beforeend',
                  `<div class="alert text-red_light mt-4" role="alert"><p>${response.message}<?</div>`,
                );

                setTimeout(() => {
                  const alert = this.form.querySelector('.alert');
                  if (alert) {
                    alert.remove();
                  }
                }, 5000);
              } else if (response.newKit.id) {
                window.location.href = `https://activateyourkit.com/kit-registration?${urlParams}`;
                localStorage.setItem('siphoxKitID', null);
              }
            });
        });
      }
    }
  }

  customElements.define('siphox-register-form', SiphoxRegisterForm);
}
